import { withNamespaces } from 'react-i18next';
import { Button, Input } from 'reactstrap';

const SETUP_STEPS = [
    {
        titleKey: 'Create an App Registration',
        bodyKey: 'Azure Portal → App registrations → New registration (in this tenant).',
    },
    {
        titleKey: 'Add delegated permissions',
        items: ['IMAP.AccessAsUser.All', 'SMTP.Send', 'offline_access'],
        bodyKey: 'Add admin consent if your tenant requires it.',
    },
    {
        titleKey: 'Create a Client Secret',
        bodyKey: 'Certificates & secrets → New client secret → copy the Value immediately (not Secret ID).',
    },
    {
        titleKey: 'Add the Redirect URI',
        bodyKey: 'Authentication → Add a platform → Web → paste the Redirect URI below.',
    },
    {
        titleKey: 'Return to Mailer Settings',
        bodyKey: 'Paste Tenant ID, Application (client) ID, and secret Value into SIP → Save → Connect Microsoft.',
    },
];

const EntraSetupDrawer = ({
    t,
    isOpen,
    redirectUri,
    onClose,
    onCopyRedirectUri,
}) => (
    <>
        <div
            className={`offcanvas offcanvas-end mailer-settings__drawer${isOpen ? ' show' : ''}`}
            tabIndex="-1"
            aria-hidden={!isOpen}
        >
            <div className="offcanvas-header border-bottom">
                <h5 className="offcanvas-title font-size-16">
                    {t('Microsoft Entra setup')}
                </h5>
                <Button
                    type="button"
                    close
                    aria-label={t('Close')}
                    onClick={onClose}
                />
            </div>

            <div className="offcanvas-body">
                <p className="text-muted font-size-13">
                    {t('Each customer organization uses their own Entra app. SIP does not use a shared Entra app.')}
                </p>

                <ol className="list-unstyled mb-4">
                    {SETUP_STEPS.map((step, index) => (
                        <li key={step.titleKey} className="d-flex mb-3">
                            <span className="mailer-settings__step-number bg-primary text-white rounded-circle d-inline-flex align-items-center justify-content-center flex-shrink-0 me-2 font-size-12 fw-semibold">
                                {index + 1}
                            </span>
                            <div>
                                <div className="fw-semibold font-size-13">
                                    {t(step.titleKey)}
                                </div>
                                {step.items && (
                                    <ul className="text-muted font-size-12 mb-1 ps-3">
                                        {step.items.map((item) => (
                                            <li key={item}>
                                                <code>{item}</code>
                                            </li>
                                        ))}
                                    </ul>
                                )}
                                {step.bodyKey && (
                                    <div className="text-muted font-size-12">
                                        {t(step.bodyKey)}
                                    </div>
                                )}
                            </div>
                        </li>
                    ))}
                </ol>

                <div className="fw-semibold font-size-13 mb-1">
                    {t('Redirect URI')}
                </div>
                {redirectUri ? (
                    <div className="d-flex align-items-center">
                        <Input
                            type="text"
                            className="form-control font-size-12"
                            value={redirectUri}
                            readOnly
                        />
                        <Button
                            type="button"
                            color="light"
                            className="ms-2 text-nowrap"
                            onClick={onCopyRedirectUri}
                        >
                            <i className="ri-file-copy-line align-middle me-1" />
                            {t('Copy')}
                        </Button>
                    </div>
                ) : (
                    <div className="text-muted font-size-12">
                        {t('Redirect URI is not configured on the server.')}
                    </div>
                )}
            </div>
        </div>

        {isOpen && (
            <div
                className="offcanvas-backdrop fade show"
                onClick={onClose}
            />
        )}
    </>
);

export default withNamespaces()(EntraSetupDrawer);
